





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { HSLColor } from '../types/color';
import SavedPalette from './SavedPalette.vue';

@Component({ components: { SavedPalette } })
export default class SavedPalettes extends Vue {
  @Prop() palettes!: HSLColor[];

  open = true;

  removePalette(key: number) {
    this.$emit('remove', key);
  }

  copyValue(color: string) {
    this.$emit('copy', color);
  }

  editPalette(palette: Array<HSLColor>) {
    this.$emit('editPalette', [...palette]);
  }
}
